export default {
  file_type_provided: "File type provided",
  image_file_support: "Only image file types are supported.",
  image_select: "Select image for profile picture.",
  image_select_gallery: "From Gallery",
  image_select_take_photo: "Take Photo",
  permission_camera_storage: "Permission for Camera or Storage are required to change picture.",
  profile_picture: "Profile Picture",
  image_delete_dialog_title: "Delete User Avatar",
  image_delete_dialog_content: "Are you sure you want to delete your user avatar?",
}
